import { Cashflow, CashflowForm, KIND_META } from '../types/cashflow';
import { http } from './http';

/** 저장 본문 — 종류가 무엇을 요구하는지는 KIND_META 가 안다 — 화면과 저장이 같은 것을 본다 */
const body = (form: CashflowForm) => {
  const meta = KIND_META[form.kind];
  return {
    vehicleId: form.vehicleId,
    dealId: meta.needs === 'deal' ? form.dealId : null,
    participantId: meta.needs === 'participant' ? form.participantId : null,
    direction: meta.direction, kind: form.kind,
    feeKind: form.kind === 'fee' ? form.feeKind : null,
    amount: form.amount ?? 0, occurredOn: form.occurredOn, memo: form.memo.trim(),
  };
};

/** 원장 — /api/cashflows. 종류 ↔ 방향 · 필수값은 DB CHECK 도 막는다 */
export const cashflowApi = {
  /** 최신순. 같은 날이면 나중에 들어온 것이 위로 */
  async list(): Promise<Cashflow[]> {
    const rows = await http.get<Cashflow[]>('/cashflows');
    return rows.map((r) => ({ ...r, memo: r.memo ?? '' })).sort((a, b) => b.occurredOn.localeCompare(a.occurredOn) || b.id - a.id);
  },
  create(form: CashflowForm): Promise<Cashflow> {
    return http.post<Cashflow>('/cashflows', body(form));
  },
  /** 기록 고치기 — 원장 줄을 누르면 연다(2026-11-02). 종류를 바꾸면 방향 · 필수값도 따라 바뀐다 */
  update(id: number, form: CashflowForm): Promise<Cashflow> {
    return http.patch<Cashflow>(`/cashflows/${id}`, body(form));
  },
  async remove(id: number): Promise<void> {
    await http.del(`/cashflows/${id}`);
  },
};
